import { render, staticRenderFns } from "./My-3-Waiting.vue?vue&type=template&id=52f40af6&"
import script from "./My-3-Waiting.vue?vue&type=script&lang=js&"
export * from "./My-3-Waiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports